import { LayoutDashboard, ShieldCheck, Bell, CheckSquare } from 'lucide-react';
import AiChat from '@/components/shared/AiChat';
import WorkspaceShell from './WorkspaceShell';

const navItems = [
  { to: '/app/validateur/dashboard', icon: LayoutDashboard, label: 'Tableau de bord' },
  { to: '/app/validateur/queue',     icon: CheckSquare,     label: 'File de validation' },
  { to: '/app/validateur/lexbase',   icon: ShieldCheck,     label: 'Validation VaegBase' },
  { to: '/app/validateur/notifications', icon: Bell,        label: 'Notifications', badge: true },
];

export default function ValidateurLayout() {
  return <WorkspaceShell title="Espace validation" items={navItems} quickPaths={['dashboard', 'queue', 'lexbase']}><AiChat /></WorkspaceShell>;
}
